import { useState, useEffect, useRef } from "react";
import ScrollContainer from "react-indiana-drag-scroll";
import { CommonCategory } from '@/components/common/category';
import { HeaderBack } from '@/components/common/header';
import _ from "lodash";
import { PopularTyreBrands, TyreListByBrand } from ".";
import { _postURL } from "../../pages/api";
import { _getAllTyreTopList, _getAllTyreModelList } from "../../libraries/common";
import { useRouter } from "next/router";
import { mobileViewWidth, pageLink } from "../../config/site";
import { SkeletonParagraph } from "../common/skeleton";
import { Skeleton } from "@mantine/core";
import Redux from "@/action";
import { Footer } from "../common/footer";
import Head from "next/head";
import { AllMeta } from '@/components/common/meta';
import Link from "next/link";
import { MyBody } from "../body/body";

export const TyreBrands = (props) => {
    const { t, device, session, params, fetchedData, query } = props
    const { store, dispatch } = Redux();
    const [loading, setLoading] = useState(true)
    const [loading2, setLoading2] = useState(true)
    const containerRef = useRef(null)

    // category
    const [activeCategory, setActiveCategory] = useState(0)

    // Tyre model List
    const [tyreModelList, setTyreModelList] = useState([])

    useEffect(()=>{
        let isMounted = true; // Flag to track component mount status

        const fetchData = async() => {
            try{
                setLoading(true)
                setActiveCategory(0);
                await _getAllTyreModelList(setTyreModelList, {
                    tyreBrandId: fetchedData?.tyre_brand_id
                });

                if(store?.path?.dataAllTyreTopList == undefined){
                    await _getAllTyreTopList(dispatch);
                }

                // await _getDealerList({vehicleBrandId: fetchedData?.vehicle_brand_id, limit: 6, offset: 0}, setDealerList)
            } catch(error) {
                console.log(error)
            } finally {
                if (isMounted) {
                    setLoading(false)
                }
            }
        }

        if(fetchedData){
            fetchData();

            if(window.innerWidth <= mobileViewWidth){
                window.scrollTo({
                    top: 1,
                    behavior: 'instant'
                });
            } else {
                if (containerRef.current) {
                    containerRef.current.scrollTo({
                    top: 0,
                    behavior: 'instant'
                    });
                }
            }
        }

        return () => {
            isMounted = false; // Mark the component as unmounted
        };
    },[fetchedData])

    return (
        <>
            <MyBody
                t={t}
                containerRef={containerRef}
                headerComponent={
                    <HeaderBack 
                        t={t} 
                        searchVisible={false}
                    />
                }
            >
                <div className='vehicleBrands_header'>
                    <div className='vehicleBrands_header_inner containerPadding'>
                        <div className='vehicleBrands_header_iconBox' style={{ width: '10rem', height: '6rem' }}>
                            <div className='vehicleBrands_header_icon' style={{backgroundImage: `url(${process.env.NEXT_PUBLIC_FS_URL + fetchedData?.image_path})`}} />
                        </div>
                        <p className='fontSize_20 fontWeight_bold'>
                            {fetchedData?.name}
                        </p>
                    </div>
                    {
                        tyreModelList &&
                        <CommonCategory 
                            data={_.chain(tyreModelList)
                                .map(({ body_type }) => ({ id: body_type, text: body_type }))
                                .filter(({ id }) => id !== '-')
                                .uniqBy('id')
                                .value()
                            }
                            activeCategory={activeCategory}
                            setActiveCategory={setActiveCategory}
                            t={t}
                            loading={loading}
                        />
                    }
                </div>
                <TyreListByBrand 
                    data={
                        activeCategory != "0" ? 
                        _.chain(tyreModelList)
                        .filter(obj => obj.body_type === activeCategory)
                        .value()
                        : 
                        _.chain(tyreModelList)
                        .value()
                    } 
                    t={t} 
                    loading={loading}
                />
                <div className="vehicleBrandsPopularCarMargin">
                    <PopularTyreBrands t={t} data={store?.path?.dataAllTyreTopList?.brand} loading={store?.path?.dataAllTyreTopList == undefined ? true : false} isTyreDetail={false} />
                </div>
            </MyBody>
        </>
    )

    // return (
    //     <>
    //         <AllMeta
    //             title={t('tyreBrandPage_title', {brand: fetchedData?.name})}
    //             description={t('tyreBrandPage_meta_description', {brand: fetchedData?.name})}
    //             keyword={t('tyreBrandPage_meta_keyword', {brand: fetchedData?.name})}
    //             image={`${process.env.NEXT_PUBLIC_FS_URL}${fetchedData?.image_path}`}
    //         />
    //         <Head><title>{t('tyreBrandPage_title', {brand: fetchedData?.name})}</title></Head>
    //         <div className='bodyContainer'>
    //             <div ref={containerRef} className='contentContainer'>
    //                 <HeaderBack 
    //                     t={t} 
    //                     searchVisible={false}
    //                 />
    //                 <div className='vehicleBrands_header'>
    //                     <div className='vehicleBrands_header_inner containerPadding'>
    //                         <div className='vehicleBrands_header_iconBox' style={{ width: '10rem', height: '6rem' }}>
    //                             <div className='vehicleBrands_header_icon' style={{backgroundImage: `url(${process.env.NEXT_PUBLIC_FS_URL + fetchedData?.image_path})`}} />
    //                         </div>
    //                         <p className='fontSize_20 fontWeight_bold'>
    //                             {fetchedData?.name}
    //                         </p>
    //                     </div>
    //                     {
    //                         tyreModelList &&
    //                         <CommonCategory 
    //                             data={_.chain(tyreModelList)
    //                                 .map(({ body_type }) => ({ id: body_type, text: body_type }))
    //                                 .filter(({ id }) => id !== '-')
    //                                 .uniqBy('id')
    //                                 .value()
    //                             }
    //                             activeCategory={activeCategory}
    //                             setActiveCategory={setActiveCategory}
    //                             t={t}
    //                             loading={loading}
    //                         />
    //                     }
    //                 </div>
    //                 <TyreListByBrand 
    //                     data={
    //                         activeCategory != "0" ? 
    //                         _.chain(tyreModelList)
    //                         .filter(obj => obj.body_type === activeCategory)
    //                         .value()
    //                         : 
    //                         _.chain(tyreModelList)
    //                         .value()
    //                     } 
    //                     t={t} 
    //                     loading={loading}
    //                 />
    //                 <div className="vehicleBrandsPopularCarMargin">
    //                     <PopularTyreBrands t={t} data={store?.path?.dataAllTyreTopList?.brand} loading={store?.path?.dataAllTyreTopList == undefined ? true : false} isTyreDetail={false} />
    //                 </div>
    //                 <Footer t={t} />
    //             </div>
    //         </div>
    //     </>
    // )
}